import { render, staticRenderFns } from "./LeaveType.vue?vue&type=template&id=0e36e6e6&"
import script from "./LeaveType.vue?vue&type=script&lang=js&"
export * from "./LeaveType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e36e6e6')) {
      api.createRecord('0e36e6e6', component.options)
    } else {
      api.reload('0e36e6e6', component.options)
    }
    module.hot.accept("./LeaveType.vue?vue&type=template&id=0e36e6e6&", function () {
      api.rerender('0e36e6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveType/LeaveType.vue"
export default component.exports